import React from 'react';
import Badge from '../../uiKit/badge';
import FlagsBlock from '../flagsBlock';
import CompatibilitiesBlock from '../compatibilitiesBlock';
import { useTranslation } from 'react-i18next';
import Title from '../../uiKit/typography/title';

export default React.memo(function GameBadgesGrid({ game, className = '' }) {
  const { t } = useTranslation('common');

  return (
    <div className={'w-full flex flex-col gap-4'}>
      <Title className={'text-3xl !text-left'}>
        {t('titles.game_details')}
      </Title>
      <div className={`grid grid-cols-2 lg:grid-cols-3 gap-4 ${className}`}>
        <Badge label={t('labels.game_type')}
               className={'bg-[#F8FAFC] !justify-start px-2 py-4 [&>label]:leading-none [&>label]:text-xs'}>
          <span
            className={'font-extrabold leading-none text-sm text-black uppercase whitespace-pre-line'}>{game.gameTypes.join(', ')}</span>
        </Badge>
        <Badge label={t('labels.theme')}
               className={'bg-[#F8FAFC] !justify-start px-2 py-4 [&>label]:leading-none [&>label]:text-xs'}>
          <span className={'font-extrabold leading-none text-sm text-black uppercase whitespace-pre-line'}>{game.theme}</span>
        </Badge>
        <Badge label={t('labels.mobile')}
               className={'bg-[#F8FAFC] !justify-start px-2 py-4 [&>label]:leading-none [&>label]:text-xs'}>
        <span
          className={'font-extrabold leading-none text-sm text-black uppercase whitespace-pre-line'}>{t('placeholders.yes')}</span>
        </Badge>
        <Badge label={t('labels.size')}
               className={'bg-[#F8FAFC] !justify-start px-2 py-4 [&>label]:leading-none [&>label]:text-xs'}>
          <span className={'font-extrabold leading-none text-sm text-black uppercase whitespace-pre-line'}>{game.size}</span>
        </Badge>
        <Badge label={t('labels.rtp')}
               className={'bg-[#F8FAFC] !justify-start px-2 py-4 [&>label]:leading-none [&>label]:text-xs'}>
          <span className={'font-extrabold leading-none text-sm text-black uppercase whitespace-pre-line'}>{game.rtp}</span>
        </Badge>
        <Badge label={t('labels.volatility')}
               className={'bg-[#F8FAFC] !justify-start px-2 py-4 [&>label]:leading-none [&>label]:text-xs'}>
          <span
            className={'font-extrabold leading-none text-sm text-black uppercase whitespace-pre-line'}>{game.volatility}</span>
        </Badge>
        <Badge label={t('labels.exposure')}
               className={'bg-[#F8FAFC] !justify-start px-2 py-4 [&>label]:leading-none [&>label]:text-xs'}>
          <span className={'font-extrabold leading-none text-sm text-black uppercase whitespace-pre-line'}>{game.maxExpose}</span>
        </Badge>
        <Badge label={t('labels.orientation')}
               className={'bg-[#F8FAFC] !justify-start px-2 py-4 [&>label]:leading-none [&>label]:text-xs'}>
        <span
          className={'font-extrabold leading-none text-sm text-black uppercase whitespace-pre-line'}>{game.gameOrientation}</span>
        </Badge>
        <Badge label={t('labels.resolution')}
               className={'bg-[#F8FAFC] !justify-start px-2 py-4 [&>label]:leading-none [&>label]:text-xs'}>
        <span
          className={'font-extrabold leading-none text-sm text-black uppercase whitespace-pre-line'}>{game.gameResolution}</span>
        </Badge>
        <Badge label={t('labels.compatible')}
               className={'bg-[#F8FAFC] !justify-start px-2 py-4 [&>label]:leading-none [&>label]:text-xs'}>
          <CompatibilitiesBlock />
        </Badge>
        <Badge label={t('labels.currencies')}
               className={'bg-[#F8FAFC] !justify-start px-2 py-4 [&>label]:leading-none [&>label]:text-xs'}>
        <span
          className={'font-extrabold leading-none text-sm text-black uppercase whitespace-pre-line'}>{t('placeholders.supported_currencies')}</span>
        </Badge>
        <Badge label={t('labels.languages')}
               className={'bg-[#F8FAFC] !justify-start px-2 py-4 [&>label]:leading-none [&>label]:text-xs'}>
          <FlagsBlock flagsData={game.supportedLanguages} className={'[&_svg]:h-6 [&_svg]:rounded-sm gap-2'}
                      withHoverEffect />
        </Badge>
      </div>
    </div>
  );
})
